// src/utils/valoriCommesse.js
// ═══════════════════════════════════════════════════════════════════════════
// VALORE DI OGNI COMMESSA PER LE VISTE SUI CLIENTI (ottobre 2026, W420)
// ═══════════════════════════════════════════════════════════════════════════
// Le schede cliente (Sintesi «Customer DNA», elenco Clienti, punteggi, scheda veloce,
// Control Center) sommavano il campo «valoreEconomico» della commessa, che la creazione
// della commessa non scrive più: risultava «Valore totale € 0» per tutti i clienti.
// Il valore vero è quello del budget: importo contrattuale + varianti accettate (lo stesso
// «Totale commessa» del Controllo Economico, utils/economiaCommessa.js). Il vecchio campo
// vale solo per le commesse storiche senza budget.
// ═══════════════════════════════════════════════════════════════════════════
import { useEffect, useMemo, useState } from "react";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../firebase";
import { totaleCommessa, numIt, budgetPrincipale } from "./economiaCommessa";

/** Mappa projectId → totale commessa dai documenti budgetCommessa (funzione pura). */
export function mappaValori(budgetDocs = []) {
  const m = new Map();
  // W450: se una commessa ha più budget vale il principale (lo stesso del Controllo Economico)
  const per = {};
  budgetDocs.forEach(b => { if (b?.projectId) (per[b.projectId] = per[b.projectId] || []).push(b); });
  Object.entries(per).forEach(([pid, lista]) => m.set(pid, totaleCommessa(budgetPrincipale(lista))));
  return m;
}

/** Le commesse con «valoreEconomico» = totale commessa del budget (o il vecchio campo, se non c'è budget). */
export function conValore(progetti = [], mappa = new Map()) {
  return progetti.map(p => (mappa.has(p.id) ? { ...p, valoreEconomico: mappa.get(p.id) } : { ...p, valoreEconomico: numIt(p.valoreEconomico) }));
}

/** Ascolta i budget dell'azienda (solo se servono: chi vede gli importi). */
export function useValoriCommesse(orgId, attivo = true) {
  const [budget, setBudget] = useState([]);
  useEffect(() => {
    if (!orgId || !attivo) { setBudget([]); return undefined; }
    return onSnapshot(query(collection(db, "budgetCommessa"), where("organizationId", "==", orgId)),
      s => setBudget(s.docs.map(d => ({ id: d.id, ...d.data() }))), () => setBudget([]));
  }, [orgId, attivo]);
  return useMemo(() => mappaValori(budget), [budget]);
}
